export default "__VITE_ASSET__DN_3nsTR__"